import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import PageLoader from './PageLoader'
import projectActions from '../PrivatePages/ProjectsPage/actions'

const PageHeader = ({
  backLinkTo = null,
  dispatch,
  fetchingStatus = 'idle',
  project = null,
  projectSlug,
  title,
  withoutHr = false
}) => {
  const { t } = useTranslation('ProjectsPage')

  if (fetchingStatus === 'idle') {
    dispatch(projectActions.fetch(projectSlug))
  }

  if (['idle', 'fetching'].includes(fetchingStatus)) {
    return (
      <PageLoader message={t('fetching')} />
    )
  }

  const backLink = backLinkTo === 'all'
    ? '/projects'
    : `/projects/${backLinkTo || project.id}`

  const backLinkText = backLinkTo === 'all'
    ? t('links.backToProjects')
    : t('links.back')

  return (
    <>
      {fetchingStatus === 'succeeded' && (
        <>
          <div className="d-flex flex-column">
            <h3 className="d-flex flex-row align-items-center mb-0">
              {project.name}
              <small className="ms-3 text-muted">
                {title}
              </small>
            </h3>
          </div>
          <Link to={backLink}>
            {backLinkText}
          </Link>
        </>
      )}

      {withoutHr === false && (<hr className="w-100 mt-2" />)}
    </>
  )
}

PageHeader.propTypes = {
  backLinkTo: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  fetchingStatus: PropTypes.string,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  projectSlug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  withoutHr: PropTypes.bool
}

const mapStateToProps = ({
  projects: {
    fetchingStatus,
    item: project
  }
}) => ({
  fetchingStatus,
  project
})

export default connect(mapStateToProps)(PageHeader)
